import React from 'react';
export function PainSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-161">
      <div className="max-w-3xl mx-auto text-center md:text-left" data-id="element-162">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-163">
          Si sos docente de primaria, dejame hacerte una pregunta honesta
        </h2>

        <p className="text-xl md:text-2xl font-bold text-red-600 mb-3 text-center" data-id="element-164">
          ¿Te pasa que cada efeméride te obliga a empezar desde cero?
        </p>

        <div className="text-lg text-gray-700 space-y-2 mb-4" data-id="element-165">
          <p data-id="element-166">No porque no sepas enseñar.</p>
          <p data-id="element-167">No porque no tengas experiencia.</p>
          <p className="font-bold" data-id="element-168">
            <span className="bg-yellow-200/50 px-1" data-id="element-169">
              Sino porque cada fecha del calendario escolar implica volver a
              buscar material, pensar actividades y preparar todo otra vez.
            </span>
          </p>
        </div>

        <ul className="space-y-2 text-lg text-gray-700 mb-4 pl-4 md:pl-8 border-l-4 border-red-500" data-id="element-170">
          <li data-id="element-171">Buscar efemérides en internet.</li>
          <li data-id="element-172">Preparar actividades a último momento.</li>
          <li data-id="element-173">Pensar qué decir en los actos escolares.</li>
          <li data-id="element-174">Repetir las mismas propuestas del año pasado.</li>
        </ul>

        <p className="text-lg text-gray-700 font-medium" data-id="element-175">
          Y entre planificaciones, clases, reuniones y correcciones terminás
          dedicando horas a algo que podría resolverse mucho más rápido.
        </p>

        <p className="text-xl font-bold text-center mt-4 text-gray-900" data-id="element-176">
          Trabajar las efemérides no debería quitarte tanto tiempo.
        </p>
      </div>
    </section>;
}